import { render } from "./AssistedEnrollmentStep1.vue?vue&type=template&id=5c98e714"
import script from "./AssistedEnrollmentStep1.vue?vue&type=script&lang=js"
export * from "./AssistedEnrollmentStep1.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__